import { StoreonModule } from 'storeon'
import dayjs from 'dayjs'
import { api } from '@/api'
import { orderRates } from '@/apps/Applications/helpers'
import { IDayOrderSurf } from '@/types'
import { Events, State } from '../../interfaces'
import { CHECK_TYPE, ORDERS } from '../../const'

export const ordersModule: StoreonModule<State, Events> = (store) => {
  let controller = new AbortController()
  store.on('@init', () => ({
    statusGetOrders: false,
    typeOrder: 1,
    ordersDay: [],
    ordersWeek: [],
    ordersInfo: {
      date: dayjs().format('YYYY.MM.DD'),
      range: 'day',
      is_show_all_order_statuses: false,
      /**
       * TODO проверить не сломалось ли ничего после undefined
       */
      customer: undefined,
      status: undefined,
      search: undefined
    },
    payOrder: undefined,
    statusTransferOrder: false,
    applicationInfo: null,
    arrayDateTimeOrders: [],
    tariffRates: [],
    tariffs: {},
    ordersCheck: [],
    isOnlinePaymentLoading: false
  }))
  store.on('isOnlinePaymentLoading/set', (state, event) => {
    return {
      isOnlinePaymentLoading: event
    }
  })
  store.on('ordersInfo/set', (state, event) => ({
    ordersInfo: { ...state.ordersInfo, ...event }
  }))
  store.on('ordersInfo/clear', () => ({
    ordersInfo: {
      date: dayjs().format('YYYY.MM.DD'),
      range: 'day',
      customer: undefined,
      status: undefined,
      search: undefined,
      is_show_all_order_statuses: false
    }
  }))
  // Получение заявок для таблицы
  store.on('orders/get', async (state) => {
    if (state.statusGetOrders) {
      controller.abort()
    }
    controller = new AbortController()
    store.dispatch('statusGetOrders/set', true)
    if (state.typeOrder === ORDERS.PIPE) {
      if (state.ordersInfo.range === 'day') {
        api.order
          .getOrdersDayAero(
            {
              ...state.ordersInfo,
              customer: Number(state.selectedUser?.id) || undefined
            },
            controller
          )
          .then((results) => {
            store.dispatch('statusGetOrders/set', false)
            store.dispatch('ordersDay/set', results)
          })
          .catch((e) => {
            if (e.message !== 'canceled') store.dispatch('statusGetOrders/set', false)
          })
      } else {
        api.order
          .getOrdersWeekAero(
            {
              ...state.ordersInfo
            },
            controller
          )
          .then((results) => {
            store.dispatch('statusGetOrders/set', false)
            store.dispatch('ordersWeek/set', results)
          })
          .catch((e) => {
            if (e.message !== 'canceled') store.dispatch('statusGetOrders/set', false)
          })
      }
    }
    if (state.typeOrder === ORDERS.WAVE) {
      if (state.ordersInfo.range === 'day') {
        api.order
          .getOrdersDaySurf(
            {
              ...state.ordersInfo,
              customer: Number(state.selectedUser?.id) || undefined
            },
            controller
          )
          .then((results) => {
            store.dispatch('statusGetOrders/set', false)
            store.dispatch('ordersDay/set', results)
          })
          .catch((e) => {
            if (e.message !== 'canceled') store.dispatch('statusGetOrders/set', false)
          })
      } else {
        api.order
          .getOrdersWeekSurf(
            {
              ...state.ordersInfo
            },
            controller
          )
          .then((results) => {
            store.dispatch('statusGetOrders/set', false)
            store.dispatch('ordersWeek/set', results)
          })
          .catch((e) => {
            if (e.message !== 'canceled') store.dispatch('statusGetOrders/set', false)
          })
      }
    }
  })

  store.on('ordersDay/set', (state, event) => {
    return {
      ordersDay: Object.entries(event).map((item: [string, IDayOrderSurf | IDayOrderSurf]) => [
        item[0],
        {
          ...item[1],
          orders: item[1].orders.map((order) => {
            if (order) {
              return {
                ...order,
                time: item[0],
                checked: false
              }
            }
            return order
          })
        }
      ])
    }
  })
  store.on('ordersWeek/set', (state, event) => ({
    ordersWeek: event
  }))
  store.on('typeOrder/set', (state, event) => ({
    typeOrder: event
  }))
  store.on('statusGetOrders/set', (state, event) => ({
    statusGetOrders: event
  }))

  store.on('changeCheckedOrder/set', (state, event) => {
    return {
      ordersDay: state.ordersDay.map((item) => [
        item[0],
        {
          ...item[1],
          orders: item[1].orders.map((order) => {
            if (order) {
              if (order.id === event) {
                return {
                  ...order,
                  checked: !order.checked
                }
              }
              if (event === 'all') {
                return {
                  ...order,
                  checked: true
                }
              }
              if (event === 'takeOf') {
                return {
                  ...order,
                  checked: false
                }
              }
              return {
                ...order
              }
            }
            return order
          })
        }
      ])
    }
  })
  // Флаг создания нескольких заявок за раз
  store.on('statusCreateMultiOrders/set', (state, event) => ({
    statusCreateMultiOrders: event
  }))
  // Флаг переноса даты в заявке
  store.on('statusTransferOrder/set', (state, event) => ({
    statusTransferOrder: event
  }))
  // Копия заявки
  store.on('applicationInfo/set', (state, event) => ({
    applicationInfo: event
  }))
  // Множественное создание записей
  store.on('arrayDateTimeOrders/add', (state, event) => ({
    arrayDateTimeOrders: [...state.arrayDateTimeOrders, event]
  }))
  store.on('arrayDateTimeOrders/delete', (state, event) => {
    if (event === 'all') {
      return { arrayDateTimeOrders: [] }
    }

    return {
      arrayDateTimeOrders: state.arrayDateTimeOrders.filter(
        (element) => element.time === event.time ? element.date !== event.date : true
      )
    }
  })
  store.on('flagOrArray/clear', () => {
    store.dispatch('statusCreateMultiOrders/set', false)
    store.dispatch('statusTransferOrder/set', false)
    store.dispatch('applicationInfo/set', null)
    store.dispatch('arrayDateTimeOrders/delete', 'all')
  })

  // Получаем тарифные ставки
  store.on('tariffRates/get', async (state, event) => {
    await api.tariff
      .getActualTariff({
        ...event,
        side: state.typeOrder
      })
      .then((response) => {
        store.dispatch('tariffRates/save', {
          tariffRates: orderRates(response),
          tariffs: response
        })
      })
      .catch(() => {
        store.dispatch('tariffRates/save', {
          tariffRates: [],
          tariffs: {}
        })
      })
  })

  store.on('tariffRates/save', (state, event) => {
    return event
  })

  store.on('tariffRates/clear', () => {
    return {
      tariffRates: [],
      tariffs: {}
    }
  })

  store.on('ordersCheck', async (state, event) => {
    let ordersCheck: number[] = []
    try {
      if (event.type === CHECK_TYPE.DEPOSIT) {
        ordersCheck = await api.tariff.depositOrdersCheck(event.data.id, {
          orders: event.data.orders,
          deposit_id: event.data.id
        })
      } else {
        ordersCheck = await api.tariff.certificateOrdersCheck(event.data.id, {
          orders: event.data.orders,
          certificate_id: event.data.id
        })
      }
      store.dispatch('ordersCheck/save', ordersCheck)
    } catch (e) {
      store.dispatch('ordersCheck/save', [])
    }
  })

  store.on('ordersCheck/save', (state, event) => {
    return {
      ordersCheck: event
    }
  })

  store.on('payOrder/get', async (state, event) => {
    try {
      const results = await api.order.getPayOrder({ ...event })
      console.log('results', results, event)
      store.dispatch('payOrder/save', results)
    } catch (e) {
      store.dispatch('payOrder/save', undefined)
    }
  })
  store.on('payOrder/save', (state, event) => {
    return { payOrder: event }
  })
}
